import escapeHtml from 'escape-html';

export default function linebreaksbr(str: string): string {
  return escapeHtml(str).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
}
